import * as React from 'react'
import { MarketingHeader } from './marketing-header'
import { MarketingFooter } from './marketing-footer'

export const MarketingLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>
    <MarketingHeader />
    <main style={{ paddingTop: 70, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {children}
    </main>
    <MarketingFooter />
  </>
)
